import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useBoundaryPanelItems');

    return {
        NO_BOUNDARIES_FOUND: t('noBoundariesFound')
    };
};

export default useTranslation;
